import { render, staticRenderFns } from "./EditTeamSocialMedia.vue?vue&type=template&id=8a76514a&scoped=true&"
import script from "./EditTeamSocialMedia.vue?vue&type=script&lang=js&"
export * from "./EditTeamSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a76514a",
  null
  
)

export default component.exports